import { all, call, takeEvery, select } from 'redux-saga/effects';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenueId, selectVenueIdRouteParam, selectUserId } from 'selectors/general';
import { ACTIVE_VENUE_CHANGED } from 'features/App';
import { doFetchOpportunities } from 'features/Opportunities/Opportunities.saga';
import { doFetchVenueSmartspotData } from 'components/SmartSpot';
import { doFetchRecommendationData } from 'components/Recommendation/Recommendation.saga';

export function* doUpdateVenueId(client, action) {
  yield call(client.navigate, makePath.home(action.venueId));
}

export function* handleHomeRouteEnter(client) {
  const shouldUpdatePath = !(yield select(selectVenueIdRouteParam));
  const venueId = yield select(selectActiveVenueId);

  // Load home page data - onboarding logic removed as part of ponboarding cleanup
  const userId = yield select(selectUserId);
  yield all([
    call(doFetchVenueSmartspotData, client, { venueId }),
    call(doFetchOpportunities, client, { venueId }),
    call(doFetchRecommendationData, client, { userId, venueId }),
  ]);

  // always redirect so the venue id is in the route
  if (shouldUpdatePath) {
    yield call(doUpdateVenueId, client, { venueId });
  }
}

export function* watchHome(client) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, doUpdateVenueId, client);
}
